import { render, staticRenderFns } from "./TableVideoItem.vue?vue&type=template&id=8163fbe0&scoped=true"
import script from "./TableVideoItem.vue?vue&type=script&lang=js"
export * from "./TableVideoItem.vue?vue&type=script&lang=js"
import style0 from "./TableVideoItem.vue?vue&type=style&index=0&id=8163fbe0&scoped=true&lang=css"
import style1 from "./TableVideoItem.vue?vue&type=style&index=1&id=8163fbe0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8163fbe0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8163fbe0')) {
      api.createRecord('8163fbe0', component.options)
    } else {
      api.reload('8163fbe0', component.options)
    }
    module.hot.accept("./TableVideoItem.vue?vue&type=template&id=8163fbe0&scoped=true", function () {
      api.rerender('8163fbe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/tableItems/TableVideoItem.vue"
export default component.exports